<template>
  <div class="bd-country-selector d-flex align-items-center">
    <select class="form-select form-select-sm" :value="selectedKey" @change="onSelectChange">
      <option value="">All Countries</option>
      <option v-for="c in countries" :key="c.id || c.code || c.name" :value="countryKey(c)">
        {{ c.name }}
      </option>
    </select>
  </div>
</template>

<script>
import { API_BASE_URL } from '@/api/bid'

export default {
  name: 'BDCountrySelector',
  data() {
    const sel = (() => {
      try { return JSON.parse(localStorage.getItem('bd_selected_country') || 'null') } catch (e) { return null }
    })()
    return {
      countries: [],
      selected: sel || null,
      selectedKey: sel ? (sel.id || sel.code || sel.name) : ''
    }
  },
  methods: {
    countryKey(c) {
      return c.id != null ? String(c.id) : (c.code || c.name || '')
    },
    async loadCountries() {
      try {
        const base = API_BASE_URL.replace(/\/+$/, '')
        const url = base + '/countries'
        const token = localStorage.getItem('access_token') ? JSON.parse(localStorage.getItem('access_token')) : null
        const headers = {
          Accept: 'application/json',
          ...(token ? { Authorization: `Bearer ${token}` } : {}),
        }
        const res = await fetch(url, { headers })
        if (!res.ok) return
        const data = await res.json()
        const list = data && (data.data || data.items || data.rows) ? (data.data || data.items || data.rows) : data
        this.countries = Array.isArray(list) ? list : []
        // ensure selectedKey stays in sync if selected present
        if (this.selected) this.selectedKey = this.countryKey(this.selected)
      } catch (e) {
        console.error('Failed to load countries', e)
      }
    },
    onSelectChange(e) {
      const key = e.target.value
      if (!key) return this.selectCountry(null)
      const found = this.countries.find(c => String(c.id) === key || String(c.code) === key || String(c.name) === key)
      this.selectCountry(found || null)
    },
    selectCountry(c) {
      this.selected = c || null
      this.selectedKey = c ? (c.id || c.code || c.name) : ''
      try { localStorage.setItem('bd_selected_country', JSON.stringify(this.selected)) } catch (e) { /* ignore */ }
      window.dispatchEvent(new CustomEvent('bd-country-changed', { detail: { country: this.selected } }))
    }
  },
  mounted() {
    this.loadCountries()
  }
}
</script>

<style scoped>
.bd-country-selector { position: relative }
.country-pill { background: transparent; border: 1px solid rgba(255,255,255,0.06); color: #fff }
.country-dropdown { position: absolute; right: 0; top: 38px; width: 210px; z-index: 60; }
.country-dropdown .list-group-item { cursor: pointer }
</style>
